// eslint-disable-next-line @typescript-eslint/no-explicit-any -- the debounced function should really accept any params
export const debounceRAF = (fn, time) => {
    const rafIdInfo = {
        id: null,
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- the debounced function should really accept any params
    return (...params) => {
        if (typeof fn !== 'function' || typeof time !== 'number') {
            return;
        }
        const startTime = window.performance.now();
        const wait = (timestamp) => {
            const elapsedTime = timestamp - startTime;
            if (elapsedTime < time) {
                clearRAFTimeout(rafIdInfo);
                rafIdInfo.id = requestAnimationFrame(wait);
            }
            else {
                clearRAFTimeout(rafIdInfo);
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument -- the debounced function should really accept any params
                fn(...params);
            }
        };
        clearRAFTimeout(rafIdInfo);
        rafIdInfo.id = requestAnimationFrame(wait);
    };
};
const clearRAFTimeout = (rafIdInfo) => {
    if (rafIdInfo && rafIdInfo.id) {
        cancelAnimationFrame(rafIdInfo.id);
    }
};
